module.exports = __webpack_public_path__ + "static/media/KcellLogo.58046042.svg";